import Vue from 'vue';
import VueFullPage from 'vue-fullpage.js';
import VueKinesis from 'vue-kinesis';
import VueGtm from 'vue-gtm';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueFullPage);
Vue.use(VueKinesis);
Vue.use(VueGtm, {id: 'GTM-PWMKXJP'});

new Vue({
	store,
	render: h => h(App),
}).$mount('#__virtual-autopsy');
